// src/api.js
import axios from "axios";
import { updateAccessToken, logout } from "./store/auth/userSlice";


const api = axios.create({
  baseURL: "/api/",
  withCredentials: true,
});

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
  return null;
}

export const setupInterceptors = (store) => {
  api.interceptors.request.use((config) => {
    const state = store.getState();
    const access = state.user?.data?.access;
    const activeProperty = state.user?.activeProperty; 

    if (access) {
      config.headers["Authorization"] = `Bearer ${access}`;
    }


    if (activeProperty && !config.url.endsWith("/token/refresh/")) {
      config.headers["X-Property-Code"] = activeProperty;
    }

    const method = (config.method || "get").toUpperCase();
    if (["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
      
      const token = getCookie("csrftoken");
      if (token) {
        config.headers["X-CSRFToken"] = token;
      }
    }
    return config;
  });

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // --- GESTIONE PASSWORD SCADUTA ---
      if (error.response?.status === 403 && error.response?.data?.code === 'password_expired') {
        // Invece di reindirizzare subito, lanciamo un evento globale
        const event = new CustomEvent('auth:password_expired', { 
          detail: error.response.data 
        });
        window.dispatchEvent(event);
        
        // Rifiutiamo la promise per fermare le operazioni in corso
        return Promise.reject(error);
      }

      // --- MAINTENANCE MODE ---- 
      if (error.response && error.response.status === 503) {
        // Previeni loop infiniti e reindirizza l'utente non-admin a una pagina statica di servizio
        if (window.location.pathname !== '/maintenance') {
            window.location.href = '/maintenance'; 
        }
        return Promise.reject(error);
      }

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const state = store.getState();
        const refreshToken = state.user?.data?.refresh;

        if (refreshToken) {
          try {
            const response = await api.post("/token/refresh/", {
              refresh: refreshToken,
            });
            
            const { access, refresh } = response.data;

            // aggiornare solo i token
            store.dispatch(updateAccessToken({ access, refresh }));

            originalRequest.headers["Authorization"] = `Bearer ${access}`;
            
            // ritenta richiesta originale con il nuovo token
            return api(originalRequest);
          } catch (refreshError) {
            store.dispatch(logout());
            window.location.href = "/auth/login";
            return Promise.reject(refreshError);
          }
        } else {
          store.dispatch(logout());
          window.location.href = "/auth/login";
        }
      }
      return Promise.reject(error);
    }
  );
};

export default api;
